import { action } from 'easy-peasy';
import { IActionSetCarePlan } from '../types';

const setCarePlan: IActionSetCarePlan = action((state, payload) => {
  state.item = payload;
});

export default setCarePlan;
